import styles from './JobMailWrapper.less';

import React, { Component, PropTypes } from 'react';
import JobMail from './JobMail';

class JobMailWrapper extends Component {
  static propTypes = {
    prompt: PropTypes.string.isRequired
  }

  render() {
    const { prompt } = this.props;
    return (
      <section className={styles.root} data-automation="savePanel">
        <h1 className={styles.savePrompt}>{prompt}</h1>
        <JobMail />
      </section>
    );
  }
}

export default JobMailWrapper;



/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/SavePanel/components/JobMailOld/JobMailWrapper.js
 **/